<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's' || $screen === 'm'
      }
    ]"
  >
    <BaseSpinner v-if="!adyenAppStateLoaded" />
    <Verify
      v-test="'sp-verification'"
      v-else-if="verificationCheck"
    />
    <Profile v-else />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { useAdyenStore } from '@/stores/adyen';
import Profile from './profile/index.vue';
import Verify from './Verify.vue';

const { adyenAppState, adyenAppStateLoaded, hasTerminals } = storeToRefs(
  useAdyenStore(),
);

const verificationCheck = computed(() => {
  const { verificationStatus } = adyenAppState.value;
  return verificationStatus === 'INVALID' && !hasTerminals.value;
});
</script>
<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: $spacing;

  &.smallScreen {
    flex-direction: column;
  }
}
</style>
